module.exports = __webpack_public_path__ + "static/media/bogota-5.4ceec0af.jpg";